import {FC, HtmlHTMLAttributes} from 'react'
import {useLayout} from '../../core'
import {DefaultTitle} from '../header/page-title/DefaultTitle'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
interface ToolbarProps extends HtmlHTMLAttributes<HTMLDivElement> {
  router?: any
  subtitle?: any
  icon: boolean
}

const Toolbar2: FC<ToolbarProps> = (props) => {
  const {classes} = useLayout()
  const navigate = useNavigate()
  let goBack = () => {
    navigate(-1)
  }
  return (
    <div className='toolbar' id='kt_toolbar'>
      {/* begin::Container */}
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
      >
        <DefaultTitle />

        {props.icon ? (
          <Link className='btn btn-sm btn-primary' to={props.router}>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
            {props.subtitle}
          </Link>
        ) : (
          <button className='btn btn-sm  btn-secondary fs-9 px-3 m-1' onClick={goBack}>
            {props.subtitle}
          </button>
        )}

        {/* begin::Button */}

        {/* end::Actions */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export {Toolbar2}
